import type { CrudConfig } from '@/components/GenericCrudPage';

/**
 * 用户管理 — 不允许后台直接删除/创建用户 (走专属注册流), 仅支持冻结/解冻/编辑资料.
 */
export const usersConfig: CrudConfig = {
  resource: 'users',
  title: '用户管理',
  rowKey: 'id',
  searchFields: ['email', 'is_active'],
  disableCreate: true,
  disableDelete: true,
  fields: [
    { name: 'id', label: 'ID', type: 'readonly', width: 80, readonly: true, hideInForm: true },
    { name: 'email', label: '邮箱', type: 'text', copyable: true, width: 220, readonly: true },
    { name: 'identity_uuid', label: '身份 UUID', type: 'text', copyable: true, width: 260, readonly: true, hideInTable: true },
    { name: 'username', label: '用户名', type: 'text', width: 140, hideInSearch: true },
    {
      name: 'account_type',
      label: '账号类型',
      type: 'select',
      width: 110,
      readonly: true,
      options: [
        { label: '主账号', value: 'MASTER', color: 'blue' },
        { label: '子账号', value: 'SUBACCOUNT', color: 'cyan' },
      ],
    },
    { name: 'is_active', label: '启用', type: 'boolean', width: 90 },
    { name: 'is_staff', label: '员工', type: 'boolean', width: 90, hideInSearch: true },
    { name: 'is_superuser', label: '超管', type: 'boolean', width: 90, hideInSearch: true },
    { name: 'last_login', label: '最近登录', type: 'datetime', width: 180, readonly: true, hideInForm: true },
    { name: 'date_joined', label: '注册时间', type: 'datetime', width: 180, readonly: true, hideInForm: true },
  ],
};
